import { render, staticRenderFns } from "./KernelPackageReturnItems.vue?vue&type=template&id=4ac812e2&"
import script from "./KernelPackageReturnItems.vue?vue&type=script&lang=js&"
export * from "./KernelPackageReturnItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports